import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import { PAGINATION_CONFIGURATION } from 'src/constants';
import { HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { PaginationResponseDTO } from 'src/dto/base.dto';
import { GetListChangeChangeRequestDto } from 'src/dto/change-request.dto';
import { IChangeRequest } from 'src/interfaces/change-request';
import { IHttpService } from 'src/services/http.service';

export interface IChangeRequestHistoryStore {
	changeRequest: IChangeRequest[];
	currentPage: number;
	total: number;
	loadChangeRequest(page: number): Promise<void>;
	dispose(): void;
}

export class ChangeRequestHistoryStore implements IChangeRequestHistoryStore {
	changeRequest: IChangeRequest[] = [];
	currentPage = 1;
	total = 0;

	constructor(private readonly http: IHttpService) {
		makeAutoObservable(this, {
			changeRequest: observable,
			dispose: action
		});
	}

	public async loadChangeRequest(page: number): Promise<void> {
		const dto = new GetListChangeChangeRequestDto({
			pageNumber: page,
      pageSize: PAGINATION_CONFIGURATION.DEFAULT_PAGE_SIZE
		});
		const res: PaginationResponseDTO<IChangeRequest[]> = await this.http.request(dto);
		if (res.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				this.changeRequest = res.data && res.data.length ? res.data : [];
				this.currentPage = page;
				this.total = res.totalRecords || 0;
			});
		}
	}

	public dispose(): void {
		this.currentPage = 1;
		this.changeRequest = [];
	}
}
